import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ReactChild, useRef } from 'react';
import { SwiperProps } from 'swiper/react/swiper-react';
import 'swiper/css';
import './carousel.css';

interface CarouselProps<T> {
    items: T[];
    itemRenderFn: (item: T) => ReactChild;
    swiperProps?: SwiperProps;
}

export default function Carousel<T>({ items, itemRenderFn, swiperProps }: CarouselProps<T>) {
    const swiper: any = useRef();
    const onSwipe = (next: boolean) => {
        if (next) {
            swiper.current?.slideNext();
        } else {
            swiper.current?.slidePrev();
        }
    };
    return (
        <div className="ui-carousel">
            <div style={{ overflow: 'hidden' }}>
                <Swiper
                    onSwiper={(sw) => (swiper.current = sw)}
                    spaceBetween={30}
                    slidesPerView={3}
                    modules={[Autoplay]}
                    autoplay={true}
                    breakpoints={{
                        0: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 3,
                        },
                        1280: {
                            slidesPerView: 4,
                        },
                    }}
                    {...swiperProps}
                >
                    {items.map((item, idx) => (
                        <SwiperSlide key={idx}>{itemRenderFn(item)}</SwiperSlide>
                    ))}
                </Swiper>
            </div>

            <div
                onClick={() => onSwipe(false)}
                className="swiper-button-prev carousel-arrow carousel-arrow--left"
            >
                <i className="icon-arrow-left" />
            </div>
            <div
                onClick={() => onSwipe(true)}
                className="swiper-button-next carousel-arrow carousel-arrow--right"
            >
                <i className="icon-arrow-right" />
            </div>
        </div>
    );
}
